import { useUserProfile } from "@src/components/user/user-context";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function usePostHogPageView() {
	const posthog = usePostHog();
	const location = useLocation();
	const {
		user: [user],
	} = useUserProfile();

	// biome-ignore lint/correctness/useExhaustiveDependencies: location.pathname is the trigger
	useEffect(() => {
		posthog.capture("$pageview", {
			email: user?.email,
			name: user?.displayName,
		});
	}, [location.pathname]);
}
